import { createElement as h } from "react"

import { IconButton as MuiIconButton } from "@mui/material"
import { makeStyles } from "@mui/styles"
import T from "prop-types"
import { and, not } from "ramda"

import { Data } from "@cirrus/fe-lib"

import { GUIElement } from "../../../lib/_public"
import { Icon, MuiIcon, Progress } from "../../atoms"

const useOverrides = makeStyles(() => ({
  root: ({ size }) => ({
    "&.MuiIconButton-root": {
      "& .MuiIcon-root": {
        fontSize: size,
      },
      "& .MuiSvgIcon-root": {
        fontSize: size,
      },
      fontSize: "unset",
    },
    "&:focus": {
      outline: "none",
    },
    fontSize: "unset",
  }),
}))

export const IconButton = ({
  className,
  color,
  customContent,
  disabled,
  muiName,
  name,
  pending = false,
  shade,
  size,
  ...props
}) =>
  h(
    MuiIconButton,
    Data.merged(props, { classes: useOverrides({ size }), disabled }),

    GUIElement.withPlaceholder({
      content: [
        muiName ? MuiIcon[muiName] : Icon,
        Data.merged(and(not(muiName), { customContent }), {
          className,
          color: disabled ? "disabled" : color,
          disabled,
          name,
          shade,
          size,
          ["data-title"]: props["data-title"]
        }),
      ],

      displayed: not(pending),
      placeholder: [Progress.Circular, { color, size }],
    }),
  )

IconButton.propTypes = {
  className: T.string,
  color: T.string,
  customContent: T.string,
  disabled: T.bool,
  muiName: T.string,
  name: T.string,
  onClick: T.func,
  pending: T.bool,
  shade: T.string,
  size: T.oneOfType([T.number, T.string]),
}
